<script>
import NotificationCenter from '@components/NotificationCenter';

export default {
  components: {
    NotificationCenter,
  },
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$wait.start('global loading');
      this.$store
        .dispatch('auth/logout', {
          router: this.$router,
        })
        .then(() => {
          this.$wait.end('global loading');
        });
    },
  },
};
</script>

<template>
  <b-navbar toggleable="md" class="border-bottom" variant="dark" type="dark" :sticky="true">
    <b-navbar-brand to="/">
      <img src="@assets/images/logo.gif" class="d-inline-block align-top" alt="KKS" height="30px" />
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-collapse id="nav_collapse" is-nav>
      <b-navbar-nav>
        <template v-if="$store.state.auth.authenticated">
          <b-nav-item :to="{ name: 'home.index' }">{{ $t('titles.home') }}</b-nav-item>
          <b-nav-item :to="{ name: 'calendar.index' }">{{ $t('titles.calendar') }}</b-nav-item>
          <b-nav-item :to="{ name: 'reports.index' }">{{ $t('titles.reports') }}</b-nav-item>
          <b-nav-item :to="{ name: 'downloads.index' }">{{ $t('titles.downloads') }}</b-nav-item>
          <b-nav-item :to="{ name: 'point-of-interests.index' }">{{ $t('titles.poi') }}</b-nav-item>
          <b-nav-item :to="{ name: 'news.index' }">{{ $t('titles.news') }}</b-nav-item>
          <b-nav-item :to="{ name: 'profile.index' }">{{ $t('titles.profile') }}</b-nav-item>
          <b-nav-item v-if="$store.state.auth.user.invoice_issuer === 0" :to="{ name: 'leaves.index' }">{{ $t('titles.leave') }}</b-nav-item>
          <b-nav-item @click="logout">{{ $t('titles.logout') }}</b-nav-item>
        </template>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <template v-if="!$store.state.auth.authenticated">
          <b-nav-item active-class="active" :to="{ name: 'login.index' }">{{ $t('titles.login') }}</b-nav-item>
          <b-nav-item active-class="active" :to="{ name: 'register.index' }">{{ $t('titles.register') }}</b-nav-item>
        </template>
        <template v-else>
          <NotificationCenter />
          <img
            v-if="$store.state.auth.user.avatar"
            class="mb-sm-0 mr-2 rounded-circle d-none d-sm-block"
            height="40"
            :src="$store.state.auth.user.avatar.small"
            alt="Avatar"
          />
          <img v-else class="mb-sm-0 mr-2 rounded-circle d-none d-sm-block" height="40" src="@assets/images/none.png" alt="Avatar" />
          <b-nav-item>{{ $store.state.auth.user.name }}</b-nav-item>
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<style scoped>
.navbar-nav .nav-link.router-link-exact-active {
  color: #fff;
}
</style>
